import * as THREE from 'three'
import { bezier2D } from '../../Utils/Bezier'
import Experience from '../../Experience'
import { ParametricGeometry } from 'three/examples/jsm/Addons.js'
import anim from '../../Utils/Anim'
import vertexShader from '../../../shaders/blob/vertex.glsl'
import fragmentShader from '../../../shaders/blob/fragment.glsl'
export default class Blob {
    constructor(_options) {
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.time = this.experience.time
        this.ui = this.experience.debug.ui
        this.position = _options.position
        this.noise = _options.noise
        this.noise.wrapS = THREE.RepeatWrapping
        this.noise.wrapT = THREE.RepeatWrapping



        // 
        this.setMesh()
        // this.setDebug()
    }

    setMesh() {
        this.geometry = new THREE.SphereGeometry(0.3, 16, 16)
        // this.material = new THREE.MeshNormalMaterial({ side: THREE.DoubleSide, wireframe: false })
        this.material = new THREE.ShaderMaterial({
            vertexShader,
            fragmentShader,

            wireframe: false,
            transparent: true,
            uniforms: {
                u_time: new THREE.Uniform(0),
                u_amplitude: new THREE.Uniform(0.5),
                u_powerShine: new THREE.Uniform(0.1),
                u_noiseTexture: new THREE.Uniform(this.noise),
            }
        })
        this.mesh = new THREE.Mesh(this.geometry, this.material)
        this.mesh.position.copy(this.position)
        this.mesh.layers.enable(1)
        this.mesh.scale.set(0.2, 0.14, 0.14)
        this.mesh.rotation.x = Math.PI
        // this.mesh.scale.set(0.5, 0.5, 0.5)
        this.scene.add(this.mesh)


    }
    live() {
        this.mesh.position.set(0, 0.7, -0.5)
        this.mesh.scale.set(0, 0.3, 0)

        anim.to(this.mesh.position, {
            duration: 0.5,
            easing: 'power1.in',
            y: 0.36
        })
        anim.to(this.mesh.scale, {
            duration: 0.5,
            easing: 'power1.in',
            // x: 1,
            // y: 1,
            // z: 1,
            x: 0.2,
            y: 0.14,
            z: 0.14,
        })


    }
    destroy() {
        if (this.mesh) {
            this.scene.remove(this.mesh)
        }
        if (this.geometry) {
            this.geometry.dispose()
        }
        if (this.material) {
            this.material.dispose()
        }
 

    }

    setDebug() {
        if (this.experience.debug.active) {
            const ui = this.experience.debug.ui
            const blobFolder = ui.addFolder('blob')
            blobFolder.add(this.mesh.position, "x").min(-2).max(2).step(0.001)
            blobFolder.add(this.mesh.position, "y").min(-2).max(2).step(0.001)
            blobFolder.add(this.mesh.position, "z").min(-2).max(2).step(0.001)
            blobFolder.add(this.mesh.scale, "y").min(0).max(0.5).step(0.001)
        }
    }
    update() {

    }

}